import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchNotificationsList } from "../../apis/notificationList";
import type { RootState } from "../reducers/reducer";

export const fetchNotificationListData = createAsyncThunk(
  "notificationlList/fetchNotificationList",
  async (options: { force?: boolean } | void, { rejectWithValue }) => {
    try {
      const notificationlList = await fetchNotificationsList();
      return notificationlList.data;
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (options, { getState }) => {
      if (options?.force) return true;
      const state = getState() as RootState;
      return !state.notificationList.isDataFetched;
    },
  }
);
